import { Inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AlertController, Events } from "ionic-angular";
import { BehaviorSubject } from "rxjs";
import { AuthenticationModel, CheckUtils, ConversationVoData, Guid, JabberResultCode, JabberResultError, logger, OdConfig } from "..";
import { CacheService } from "ionic-cache";
var JabberEndPoints = /** @class */ (function () {
    function JabberEndPoints(config, events, cache, translate, _authModel, alertCtrl) {
        this.config = config;
        this.events = events;
        this.cache = cache;
        this.translate = translate;
        this._authModel = _authModel;
        this.alertCtrl = alertCtrl;
        this._messageHandler = new BehaviorSubject(null);
        this._chatStateHandler = new BehaviorSubject(null);
        this._inviteHandler = new BehaviorSubject(null);
        this.extensions = [];
    }
    Object.defineProperty(JabberEndPoints.prototype, "isForcedDisconnect", {
        get: function () {
            return this._isForcedDisconnect;
        },
        enumerable: true,
        configurable: true
    });
    JabberEndPoints.prototype.signIn = function (jid, password) {
        if (CheckUtils.isEmpty(jid)) {
            logger.error("Error on sign-in in jabber end points. Jid is not defined.");
            return;
        }
        var wsURL, boshURL, transport;
        if (this.config.jabberUrl.indexOf("http") === 0) {
            boshURL = this.config.jabberUrl;
            transport = "bosh";
        }
        else if (this.config.jabberUrl.indexOf("ws") === 0) {
            wsURL = this.config.jabberUrl;
            transport = "websocket";
        }
        if (CheckUtils.isEmpty(password)) {
            this.client = XMPP.createClient({
                jid: jid,
                sasl: "anonymous",
                wsURL: wsURL,
                boshURL: boshURL,
                transport: transport
            });
        }
        else if (typeof jid != "string") {
            this.client = XMPP.createClient({
                jid: jid.bare,
                password: password,
                wsURL: wsURL,
                boshURL: boshURL,
                transport: transport
            });
        }
        this.setup();
    };
    ;
    JabberEndPoints.prototype.signOut = function () {
        if (this.client != null) {
            logger.info("jabberEndPoint - disconnect : true");
            this.forceDisconnect();
        }
    };
    JabberEndPoints.prototype.setup = function () {
        var _this = this;
        for (var _i = 0, _a = this.extensions; _i < _a.length; _i++) {
            var extension = _a[_i];
            this.client.use(extension);
        }
        this.client.on(JabberEPEvent.MESSAGE, function (data) {
            if (data == null)
                return;
            if (!_this._isConnecting)
                _this._isConnecting = true;
            else if (data.id != null &&
                data.hasOwnProperty("body")) {
                logger.info("jabberEndPoint - receive new message");
                _this._messageHandler.next(data);
            }
            else if (data.chatState != null) {
                logger.info("jabberEndPoint - receive new chat state");
                _this._chatStateHandler.next(data);
            }
        });
        this.client.on(JabberEPEvent.CHAT, function (chat) {
            logger.info("jabberEndPoint - callback of bot messageid : ");
        });
        this.client.on("muc:invite", function (invite) {
            logger.info("is now invite to: " + invite.reason + " on room " +
                ((invite.room == null) ? "undefined" : invite.room.bare));
            _this._inviteHandler.next(invite);
        });
        this.client.on("presence", function (presence) {
            if (presence.from.domain === _this.config.jabberAnonymous) {
                logger.info("jabberEndPoint - receive new presence");
                _this.events.publish(JabberEPEvent.PRESENCE_CHANGED, presence.from.bare, presence.type);
            }
            else if (presence.from.resource !== "" && _this._authModel.jid != null && presence.from.resource !== _this._authModel.jid.bare) {
                _this.events.publish(JabberEPEvent.PRESENCE_CHANGED, presence.from.resource, presence.type, presence.from.bare);
            }
        });
        this.client.on(JabberEPEvent.SESSION_STARTED, function () {
            _this.client.enableCarbons();
            _this.client.getRoster(function (err, roster) {
                _this.client.updateCaps();
            });
            _this.client.sendPresence({
                caps: _this.client.disco.caps
            });
            _this.events.publish(JabberEPEvent.JID_CHANGED, _this.client.jid);
            logger.info("jabberEndPoint - authentication current jid:" + _this.client.jid);
        });
        this.client.once(JabberEPEvent.AUTH_SUCCESS, function () {
            logger.info("jabberEndPoint - authentication success");
            _this._isConnecting = true;
            _this.client.on(JabberEPEvent.AUTH_FAILED, function (event) {
                logger.info("jabberEndPoint - authentication failed");
                _this.forceDisconnect();
                _this.errorAlert(_this.getApiResultCode(JabberResultCode.ERROR_JABBER_AUTHENTICATION_FAILED));
            });
        });
    };
    Object.defineProperty(JabberEndPoints.prototype, "isConnecting", {
        get: function () {
            return this._isConnecting;
        },
        enumerable: true,
        configurable: true
    });
    JabberEndPoints.prototype.getRoom = function (id) {
        return new ConversationVoData(id);
    };
    JabberEndPoints.prototype.joinRoom = function (conversation, jid, options) {
        if (!CheckUtils.areEmpty(this.client, jid)) {
            logger.info("jabberEndPoint - join room : " + conversation.uid);
            this.client.joinRoom(conversation.uid, jid.bare, options);
            return true;
        }
        return false;
    };
    JabberEndPoints.prototype.leaveRoom = function (conversation, jid, options) {
        if (!CheckUtils.areEmpty(this.client, jid)) {
            logger.info("jabberEndPoint - join leave : " + ((typeof conversation === "string") ? conversation : conversation.uid));
            this.client.leaveRoom((typeof conversation === "string") ? conversation : conversation.uid, jid.bare, options);
        }
    };
    JabberEndPoints.prototype.sendChatState = function (chatState) {
        if (!CheckUtils.areEmpty(this.client, chatState)) {
            logger.info("jabberEndPoint - send chat state : " + chatState.chatState);
            this.client.sendMessage(chatState);
        }
    };
    JabberEndPoints.prototype.getNewMessageJabberId = function () {
        return Guid.guid();
    };
    JabberEndPoints.prototype.sendMessage = function (message) {
        if (CheckUtils.isEmpty(this.client))
            return false;
        if (message.id == null)
            message.id = this.getNewMessageJabberId();
        logger.info("jabberEndPoint - send message with id : " + message.id);
        this.client.sendMessage(message);
        return true;
    };
    JabberEndPoints.prototype.addExtension = function (extension) {
        if (extension != null)
            this.extensions.push(extension);
    };
    JabberEndPoints.prototype.onChatStateChange = function () {
        return this._chatStateHandler.asObservable();
    };
    JabberEndPoints.prototype.onMessage = function () {
        return this._messageHandler.asObservable();
    };
    JabberEndPoints.prototype.onInvite = function () {
        return this._inviteHandler.asObservable();
    };
    JabberEndPoints.prototype.connect = function () {
        if (this.client != null && this.cache.isOnline()) {
            this._isForcedDisconnect = false;
            this.client.enableKeepAlive();
            logger.info("jabberEndPoint - try to connect");
            this.client.connect();
        }
    };
    JabberEndPoints.prototype.getApiResultCode = function (error) {
        var name = "";
        this.translate.get("Errors." + error + ".name").subscribe(function (res) { return name = res; });
        var description = "";
        this.translate.get("Errors." + error + ".description").subscribe(function (res) { return description = res; });
        return new JabberResultError(error, name, description);
    };
    JabberEndPoints.prototype.errorAlert = function (jabberErrorResult) {
        var _this = this;
        this.translate.get("OK").subscribe(function (res) {
            var alert = _this.alertCtrl.create({
                title: jabberErrorResult.name,
                subTitle: jabberErrorResult.description,
                buttons: [res]
            });
            alert.present();
        });
    };
    JabberEndPoints.prototype.onConnected = function (resolve) {
        var _this = this;
        if (this.client == null) {
            logger.error("jabberEndPoint - no client");
        }
        else {
            this.client.once(JabberEPEvent.CONNECTED, function () {
                _this._isConnecting = true;
                logger.warn("jabberEndPoint - connected");
                resolve(_this._isConnecting);
            });
            this.client.once(JabberEPEvent.DISCONNECTED, function () {
                _this._isConnecting = false;
                logger.warn("jabberEndPoint - disconnected");
                resolve(_this._isConnecting);
            });
            this.client.once(JabberEPEvent.DISCONNECTED, function () {
                _this._isConnecting = false;
                logger.warn("jabberEndPoint - connection failed");
                resolve(null);
            });
        }
    };
    JabberEndPoints.prototype.forceDisconnect = function () {
        this._isForcedDisconnect = true;
        this.client.disableKeepAlive();
        this.client.disconnect();
    };
    JabberEndPoints.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    JabberEndPoints.ctorParameters = function () { return [
        { type: OdConfig, decorators: [{ type: Inject, args: ["config",] },] },
        { type: Events, },
        { type: CacheService, },
        { type: TranslateService, },
        { type: AuthenticationModel, },
        { type: AlertController, },
    ]; };
    return JabberEndPoints;
}());
export { JabberEndPoints };
export var JabberEPEvent;
(function (JabberEPEvent) {
    JabberEPEvent["SESSION_STARTED"] = "session:started";
    JabberEPEvent["AUTH_SUCCESS"] = "auth:success";
    JabberEPEvent["AUTH_FAILED"] = "auth:failed";
    JabberEPEvent["DISCONNECTED"] = "disconnected";
    JabberEPEvent["CONNECTED"] = "connected";
    JabberEPEvent["MESSAGE"] = "message";
    JabberEPEvent["CHAT"] = "chat";
    JabberEPEvent["INVITED"] = "jabber-end-point:invited";
    JabberEPEvent["INVITED_REASON"] = "jabber-end-point:invitedReason";
    JabberEPEvent["RECONNECTED"] = "jabber-end-point-jid:reconnect";
    JabberEPEvent["JID_CHANGED"] = "jabber-end-point-jid:changed";
    JabberEPEvent["PRESENCE_CHANGED"] = "jabber-end-point-presence:changed";
    JabberEPEvent["CHAT_STATE_CHANGED"] = "jabber-end-point-chat-state:changed";
})(JabberEPEvent || (JabberEPEvent = {}));
//# sourceMappingURL=jabber-end-points.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/endpoints/jabber-end-points.js
// module id = 256
// module chunks = 14